import React, { useState } from 'react';
import classNames from 'classnames';
import { ReactTable } from '../../../../shared/ReactTable';
import DMActionsTableHead from './DMActionsTableHead';
import DMActionsTableBody from './DMActionsTableBody';
import DMActionsTableHeading from './DMActionsTableHeading';
import styles from './DMActionsTable.module.css';

function DMActionsTable({ data, isFetching, isError, columns, className }) {
  const [sorted, setSorted] = useState([
    {
      id: 'time_initiated',
      desc: true
    }
  ]);

  const handleOnSort = (newSorted) => {
    setSorted(newSorted);
  };

  return (
    <ReactTable
      className={classNames(styles.root, className)}
      data={data}
      loading={isFetching && data?.length === 0}
      columns={columns}
      resizable={true}
      showPagination={false}
      noDataText={isError ? <ErrorOverlay /> : isFetching ? '' : 'No device command found'}
      pageSize={Math.max(data?.length, 10)}
      TheadComponent={(props) => <DMActionsTableHead {...props} onSorted={handleOnSort} />}
      TbodyComponent={DMActionsTableBody}
      ThComponent={DMActionsTableHeading}
      defaultSorted={sorted}
      getTheadThProps={(props, _rowInfo, column) => ({
        sortable: column?.sortable ?? props.sortable
      })}
    />
  );
}

const ErrorOverlay = () => {
  return (
    <div className={styles.errorRoot}>
      <div>
        <div className={styles.errorTitle}>Error </div>
        <div className={styles.errorMessage}>
          An unknown error occured while getting the list of device commands. If this problem persists, please contact
          us at
          <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
        </div>
      </div>
    </div>
  );
};

export default DMActionsTable;
